<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.722 5.856h10.47c.399 0 .722-.307.722-.686 0-.378-.323-.685-.722-.685H1.722c-.399 0-.722.307-.722.685 0 .379.323.686.722.686ZM18.08 5.856h4.248c.183 0 .638-.307.638-.686 0-.378-.455-.685-.638-.685H18.08c-.184 0-.597.307-.597.685 0 .379.413.686.597.686Z"
      fill="currentColor"
    />
    <path
      clip-rule="evenodd"
      d="M12.914 5.285a2.285 2.285 0 1 0 4.57 0 2.285 2.285 0 0 0-4.57 0Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.278 12.253h-10.47c-.399 0-.722-.307-.722-.686 0-.378.323-.685.722-.685h10.47c.399 0 .722.307.722.685 0 .379-.323.686-.722.686ZM5.921 12.253H1.673c-.184 0-.639-.307-.639-.686 0-.378.455-.685.639-.685H5.92c.184 0 .596.307.596.685 0 .379-.412.686-.596.686Z"
      fill="currentColor"
    />
    <path
      clip-rule="evenodd"
      d="M11.086 11.681a2.285 2.285 0 1 1-4.57 0 2.285 2.285 0 0 1 4.57 0Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.756 18.65h10.47c.399 0 .722-.307.722-.686 0-.378-.323-.685-.722-.685H1.756c-.399 0-.722.307-.722.685 0 .379.323.686.722.686ZM18.113 18.65h4.248c.183 0 .639-.307.639-.686 0-.378-.456-.685-.64-.685h-4.247c-.184 0-.596.307-.596.685 0 .379.412.686.596.686Z"
      fill="currentColor"
    />
    <path
      clip-rule="evenodd"
      d="M12.947 18.078a2.285 2.285 0 1 0 4.57 0 2.285 2.285 0 0 0-4.57 0Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
